import React, { useState, useRef } from "react";

import ModalWithPortal from "./ModalWithPortal";

import Fullscreen from "@mui/icons-material/Fullscreen";
import { useSynchronizedState } from "@solidwhite/multiuser";

const ImageSlide = (props) => {
  const [isOpenPortal, setIsOpenPortal] = useSynchronizedState(
    `ImageFullscreen_${props.id}`,
    false
  );

  const imageRef = useRef();

  const handleOpenPortal = () => {
    setIsOpenPortal(true);
  };

  return (
    <>
      <div
        style={{
          position: "relative",
          paddingTop: "56.25%", // Player ratio: 100 / (1280 / 720)
          cursor: "pointer",
        }}
        onClick={handleOpenPortal}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            boxShadow: "0px 0px 50px 5px #000 inset",
            zIndex: 1,
            userSelect: "none",
            width: "100%",
            height: "100%",
          }}
        />
        <img
          src={props.src}
          ref={imageRef}
          id={props.id}
          alt=""
          width="100%"
          height="100%"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            objectFit: "cover",
          }}
        />
      </div>

      <div
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          cursor: "pointer",
          display: "flex",
          justifyContent: "center",
          p: "0.5vw",
        }}
        onClick={handleOpenPortal}
      >
        <Fullscreen
          style={{
            color: "#fff",
            fontSize: "2vw !important",
            marginTop: "10px",
            marginRight: "10px",
          }}
        />
      </div>

      <ModalWithPortal
        isOpenPortal={isOpenPortal}
        setIsOpenPortal={setIsOpenPortal}
        image={props.src}
      >
        <img src={props.src} alt={props.id} />
      </ModalWithPortal>
    </>
  );
};

export default ImageSlide;
